var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shield Done"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shield Done_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4788 39.0011C16.6911 39.112 16.9284 39.1684 17.1658 39.1665C17.4031 39.1646 17.6385 39.1064 17.8527 38.9936L24.6911 35.338C26.6304 34.3043 28.1489 33.1484 29.3337 31.8026C31.9097 28.8706 33.3164 25.1286 33.2913 21.27L33.2102 8.54205C33.2025 7.07605 32.2396 5.76792 30.8156 5.29241L18.0939 1.02408C17.3278 0.764713 16.4885 0.770352 15.7359 1.03724L3.06245 5.45781C1.64614 5.95211 0.700642 7.26964 0.70836 8.73752L0.789402 21.456C0.814487 25.3203 2.26939 29.0454 4.88783 31.9474C6.08417 33.2743 7.61626 34.4133 9.57672 35.4301L16.4788 39.0011ZM14.6685 24.0421C14.9541 24.3165 15.3246 24.4519 15.6951 24.4481C16.0656 24.4462 16.4341 24.3071 16.7158 24.029L24.1891 16.6614C24.7506 16.1069 24.7448 15.216 24.1775 14.6691C23.6083 14.1222 22.6917 14.1259 22.1302 14.6804L15.6739 21.0443L13.0303 18.5033C12.4611 17.9563 11.5465 17.962 10.983 18.5164C10.4215 19.0709 10.4273 19.9617 10.9965 20.5087L14.6685 24.0421Z",
    fill: "#E25858"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldDone);
export default __webpack_public_path__ + "static/media/shield-done.19940d103b724e5385697e6025f8230d.svg";
export { ForwardRef as ReactComponent };